/*global FB*/
import moment from 'moment'
import { Link } from 'found'
import { Helmet } from 'react-helmet'
import React, { Component } from 'react'
import { RichText } from 'prismic-reactjs'
import LazyLoad from 'react-lazy-load';
import { createFragmentContainer } from 'react-relay'
import graphql from 'babel-plugin-relay/macro' 

import { msToReadingTime } from '../../utils'
import LinkResolver from '../../link-resolver'

import timeIcon from '../../images/time.svg'
import arrowFIcon from '../../images/ARROW-F.svg'
// import searchIcon from '../../images/search_1.svg'
import websiteIcon from '../../images/website.svg'
import twitterIcon from '../../images/twitter.svg'
import arrowFwIcon from '../../images/ARROW-FW.svg'
import facebookIcon from '../../images/facebook.svg'
import calendarIcon from '../../images/calendar.svg'
import greyTimeIcon from '../../images/grey_time.svg'
import instagramIcon from '../../images/instagram_1.svg'
// import linkedinIcon from '../../images/email/linkedin.png'
import linkedinIconGray from '../../images/linkdin.svg'
import calendarGreyIcon from '../../images/calendar-icon_g.svg'
import quotationTopIcon from "../../images/quotation-top.svg"
import quotationBottomIcon from "../../images/quotation-bottom.svg"
// import publisherLogo from "../../images/publisher_logo.png"
import NewsletterForm from '../../components/newletter-form'
import ErrorPage from '../error-page/error-page'

import $ from 'jquery';

class ProgressBar extends Component {

    constructor() {
        super()
        this.state = {
            display: 'none',
            opacity: 0,
            width: 0,
        }
    }

    twitterLoopCounter = 0
    twitterLoop = () => {
        if (window.twttr && window.twttr.widgets) {
            window.twttr.widgets.load()
            this.loadedTwitter = true;
        } else {
            console.log('waiting...')
            if (this.twitterLoopCounter < 10) {
                this.twitterLoopCounter++;
                setTimeout(this.twitterLoop, 1000)
            }
        }
    }

    componentDidMount = () => {
        window.fbsdk()
        // window.twttr.widgets.load()
        this.twitterLoop()

        window.addEventListener('scroll', this.handleScroll)
    }

    componentWillUnmount = () => {
        window.removeEventListener('scroll', this.handleScroll)
    }

    handleScroll = (event) => {
        var hiddenAfter = calculateVisibilityForDiv($('.article_content'))
        this.setState({
            display: (window.scrollY > 80 && hiddenAfter > 0) ? 'block' : 'none',
            opacity: (window.scrollY - 100) / 650,
            width: Math.round(hiddenAfter) + '%',
        })

        if (this.loadedTwitter && document.querySelector('blockquote[class="fb-xfbml-parse-ignore"]')) {
            FB.XFBML.parse();
        }
        if (this.loadedTwitter && document.querySelector('blockquote[class="twitter-tweet"]')) {
            window.twttr.widgets.load()
        }
    }

    render() {
        return (
            <div
                className="article-bar w-hidden-small w-hidden-tiny"
                style={{
                    opacity: this.state.opacity,
                    display: this.state.display,
                }}
            >
                <div
                    data-w-id="c1617bf0-d6f1-2136-a860-df5f329baf56"
                    className="progress-bar"
                    style={{
                        width: this.state.width,
                        background: this.props.group.color
                    }}
                />
                <ul
                    style={{
                        opacity: this.state.opacity,
                        display: this.state.display,
                        marginLeft: 80,
                    }}
                    className="article-actions w-hidden-small w-hidden-tiny w-list-unstyled"
                >
                    <li className="action-list-item">
                        <a href={`https://twitter.com/home?status=${encodeURI(window.location.href)}`} target="_blank">
                            <img src={twitterIcon} width="32" height="32" alt="" className="article-action-icon twitter" />
                        </a>
                    </li>
                    <li className="action-list-item">
                        <a href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURI(window.location.href)}`} target="_blank">
                            <img src={facebookIcon} width="32" height="32" alt="" className="article-action-icon facebook" />
                        </a>
                    </li>
                </ul>
                <div className="div-block-50">
                    <div className="div-block-51">
                        <a href="/" className="w-inline-block">
                            <img alt=""
                                src={this.props.picture}
                                width={27}
                                className="image-47"
                            />
                        </a>
                        <div className="div-block-139">
                            <div className="text-block-50" style={{ color: this.props.group.color }}>
                                READING
                            </div>
                            <div className="post-title">{this.props.title}</div>
                        </div>
                        <div className="div-block-138">
                            <Link
                                to={this.props.group.link}
                                style={{ color: this.props.group.color }}
                                className="link-11"
                            >
                                More on
                            </Link>
                            <Link
                                to={this.props.group.link}
                                style={{ color: this.props.group.color, textTransform: 'uppercase' }}
                                className="link-12"
                            >
                                {this.props.group.name}
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

class ArticlePage extends Component {

    loadedTwitter = false;
    FBRegex = /class="(fb|facebook)(.)+/;
    TWTTRRegex = /class="twitter-(.)+/;
    INSTARegex = /class="instagram-(.)+/;

    render() {

        let listKey = 0;

        var blockLazy = (/blocklazy/gi).test(window.location.href);

        this.FBRegex = new RegExp(/class="(fb|facebook)(.)+/);
        this.TWTTRRegex = new RegExp(/class="twitter-(.)+/);
        this.INSTARegex = new RegExp(/class="instagram-(.)+/);

        // window.fbsdk();

        if (window.twttr && window.twttr.widgets)
            this.loadedTwitter = true;

        var imageHeader

        if (this.props.videoLink || this.props.forceTitleToAppearUnderneath) {
            let mediaPart = null
            if (this.props.videoLink) {
                mediaPart = <div className="video">
                    <div
                        style={{ paddingTop: '56.17021276595745%' }}
                        id="w-node-8234d4ae9a0e"
                        className="w-video w-embed"
                        dangerouslySetInnerHTML={{ __html: this.props.videoLink }}
                        onWheel={(e) => e.preventDefault()}
                    />
                </div>
            } else {
                mediaPart = <div
                    className="div-block-48"
                    style={{
                        background: '-webkit-linear-gradient(81deg, rgba(0, 0, 0, .38) 11%, transparent 70%), url(' + this.props.picture + ') no-repeat center',
                        backgroundSize: 'cover',
                    }}
                />
            }
            imageHeader =
                <div key="3">
                    <div className="hero-video">
                        {
                            mediaPart
                        }
                    </div>
                    <div className="header-title---video">
                        <div className="container-10 w-container">
                            <ol className="breadcrumb-video w-hidden-tiny w-list-unstyled">
                                <li className="breadcrumb-item" />
                                <li className="breadcrumb-item">
                                    <a className="link-10 grey">...</a>
                                </li>
                                <li className="breadcrumb-item">
                                    <img alt="" src={arrowFIcon} width={16} height={16} className="breadcrumb-divider" />
                                    <Link to={this.props.group.link} className="link-8 grey">{this.props.group.name}</Link>
                                </li>
                                <li className="breadcrumb-item"><img alt="" src={arrowFIcon} width={16} height={16} className="breadcrumb-divider" />
                                    <div className="active"></div>
                                </li>
                            </ol>
                            <h1 className="title-video">{this.props.title}</h1>
                            <div className="article-content-details-video w-clearfix">
                                { this.props.author && (<h5 className="article-author-video">{this.props.author.firstname} {this.props.author.lastname}</h5> )}
                                <img src={calendarGreyIcon} width="15" height="15" alt="" className="image-45" />
                                <h5 className="article-reading-time video">{this.props.publishedAt.format('DD MMM YYYY')}</h5>
                            </div>
                        </div>
                    </div>
                </div>
        } else {
            imageHeader =
                <div key="3" className="hero-image">
                    <div className="article_header">
                        <h1 className="page-title-post margin-bottom-16px-copy">{this.props.title}</h1>
                        <div className="article-content-details margin-bottom-24px w-clearfix">
                            <h5 className="article-author-copy">{this.props.author.firstname} {this.props.author.lastname}</h5>
                            <img alt="" src={timeIcon} width={15} height={15} className="image-44" />
                            <h5 className="article-reading-time">{this.props.readingTime}</h5>
                            <img alt="" src={calendarIcon} width={15} height={15} className="image-45" />
                            <h5 className="article-reading-time">{this.props.publishedAt.format('DD MMM YYYY')}</h5>
                        </div>
                        <ol className="breadcrumb w-hidden-tiny w-list-unstyled">
                            <li className="breadcrumb-item" />
                            <li className="breadcrumb-item">
                                <a className="link-10">...</a>
                            </li>
                            <li className="breadcrumb-item">
                                <img alt="" src={arrowFwIcon} width={16} height={16} className="breadcrumb-divider" />
                                <Link to={this.props.group.link} className="link-8">{this.props.group.name}</Link>
                            </li>
                            <li className="breadcrumb-item"><img alt="" src={arrowFwIcon} width={16} height={16} className="breadcrumb-divider" />
                                <div className="active"></div>
                            </li>
                        </ol>
                    </div>
                    <div
                        className="div-block-48"
                        style={{
                            background: '-webkit-linear-gradient(81deg, rgba(0, 0, 0, .38) 11%, transparent 70%), url(' + this.props.picture + ') no-repeat center',
                            backgroundSize: 'cover',
                        }}
                    />
                </div>
        }

        var recomendations
        if (!blockLazy) {
            recomendations =
                <LazyLoad key="5" offsetVertical={100} debounce={false}>
                    <div className="recomended">
                        {this.props.group.latestArticles.length !== 0 &&
                            <div className="category-related-articles">
                                <div className="text-block-53" style={{ color: this.props.group.color }}>More on</div>
                                <div className="text-block-56" style={{ color: this.props.group.color, textTransform: 'uppercase' }}>
                                    {this.props.group.name}
                                </div>
                                <div className="row-business w-row">
                                    {this.props.group.latestArticles.slice(0, 3).map((a, k) =>
                                        <div key={k} className="column-35 w-col w-col-4">
                                            {a.link && <Link to={a.link} className="link-block-9 w-inline-block" />}
                                            <img alt="" src={a.picture} className="image-headline primary" />
                                            <div
                                                className="div-block-16 busines"
                                                style={{ background: this.props.group.color }}
                                            />
                                            <div>
                                                <h3 className="heading-22 healdine">{a.title}</h3>
                                                <p className="paragraph-3">{a.caption}</p>
                                            </div>
                                            <div className="div-block-15">
                                                {a.author && (<div className="grey">{a.author.firstname} {a.author.lastname}</div>)}
                                                <img alt="" src={greyTimeIcon} width={13} height={13} className="image-24" />
                                                <div className="grey2">{msToReadingTime(a.readingTime)}</div>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        }
                        {this.props.group.articles.length > 3 &&
                            <div className="you-may-like w-hidden-small w-hidden-tiny">
                                <div className="row-business w-row">
                                    {this.props.group.latestArticles.slice(3, 6).map((a, k) =>
                                        <div key={k} className="column-35 w-col w-col-4">
                                            {a.link && <Link to={a.link} className="link-block-9 w-inline-block" />}
                                            <img alt="" src={a.picture} className="image-headline primary" />
                                            <div
                                                className="div-block-16 busines"
                                                style={{ background: this.props.group.color }}
                                            />
                                            <div>
                                                <h3 className="heading-22 healdine">{a.title}</h3>
                                                <p className="paragraph-3">{a.caption}</p>
                                            </div>
                                            <div className="div-block-15">
                                                {a.author && (<div className="grey">{a.author.firstname} {a.author.lastname}</div>)}
                                                <img alt="" src={greyTimeIcon} width={13} height={13} className="image-24" />
                                                <div className="grey2">{msToReadingTime(a.readingTime)}</div>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        }
                        {/*<div className="h-divider" />
                            <div className="comments-section">
                                <div className="comments-container">
                                    <h4 className="headline-5 margin-bottom-16px">Comments (5)</h4>
                                    <div className="comment-box margin-bottom-16px">
                                        <div className="text-block-52">Write your comment here...</div>
                                    </div>
                                    <div className="load-more-comments-button">
                                        <div className="text-block-4">SHOW&nbsp;COMMENTS</div>
                                    </div>
                                </div>
                            </div>*/}
                    </div>
                </LazyLoad>

        } else {
            recomendations =
                <div key="5" className="recomended">
                    {this.props.group.latestArticles.length !== 0 &&
                        <div className="category-related-articles">
                            <div className="text-block-53" style={{ color: this.props.group.color }}>More on</div>
                            <div className="text-block-56" style={{ color: this.props.group.color, textTransform: 'uppercase' }}>
                                {this.props.group.name}
                            </div>
                            <div className="row-business w-row">
                                {this.props.group.latestArticles.slice(0, 3).map((a, k) =>
                                    <div key={k} className="column-35 w-col w-col-4">
                                        {a.link && <Link to={a.link} className="link-block-9 w-inline-block" />}
                                        <img alt="" src={a.picture} className="image-headline primary" />
                                        <div
                                            className="div-block-16 busines"
                                            style={{ background: this.props.group.color }}
                                        />
                                        <div>
                                            <h3 className="heading-22 healdine">{a.title}</h3>
                                            <p className="paragraph-3">{a.caption}</p>
                                        </div>
                                        <div className="div-block-15">
                                            {a.author && (<div className="grey">{a.author.firstname} {a.author.lastname}</div>)}
                                            <img alt="" src={greyTimeIcon} width={13} height={13} className="image-24" />
                                            <div className="grey2">{msToReadingTime(a.readingTime)}</div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    }
                    {this.props.group.articles.length > 3 &&
                        <div className="you-may-like w-hidden-small w-hidden-tiny">
                            <div className="row-business w-row">
                                {this.props.group.latestArticles.slice(3, 6).map((a, k) =>
                                    <div key={k} className="column-35 w-col w-col-4">
                                        {a.link && <Link to={a.link} className="link-block-9 w-inline-block" />}
                                        <img alt="" src={a.picture} className="image-headline primary" />
                                        <div
                                            className="div-block-16 busines"
                                            style={{ background: this.props.group.color }}
                                        />
                                        <div>
                                            <h3 className="heading-22 healdine">{a.title}</h3>
                                            <p className="paragraph-3">{a.caption}</p>
                                        </div>
                                        <div className="div-block-15">
                                            {a.author && (<div className="grey">{a.author.firstname} {a.author.lastname}</div>)}
                                            <img alt="" src={greyTimeIcon} width={13} height={13} className="image-24" />
                                            <div className="grey2">{msToReadingTime(a.readingTime)}</div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    }
                    {/*<div className="h-divider" />
                            <div className="comments-section">
                                <div className="comments-container">
                                    <h4 className="headline-5 margin-bottom-16px">Comments (5)</h4>
                                    <div className="comment-box margin-bottom-16px">
                                        <div className="text-block-52">Write your comment here...</div>
                                    </div>
                                    <div className="load-more-comments-button">
                                        <div className="text-block-4">SHOW&nbsp;COMMENTS</div>
                                    </div>
                                </div>
                            </div>*/}
                </div>
        }
        console.log("AUTHOR", this.props.author);
        return [
            <Helmet key="1">
                <title>{this.props.seo.title ? this.props.seo.title : "Startup Guide - " + this.props.title}</title>
                <meta content={this.props.seo.description ? this.props.seo.description : this.props.caption} name="description" />

                { this.props.author && (<meta property="article:author" content={this.props.author.firstname + ' ' + this.props.author.lastname} /> )}
                <meta property="article:published_time" content={this.props.publishedAt.format('YYYY-MM-DD')} />
                <meta property="og:type" content="article" />
                <meta property="og:title" content={this.props.generic && this.props.generic.title ? this.props.generic.title : this.props.title} />
                <meta property="og:description" content={this.props.generic && this.props.generic.description ? this.props.generic.description : this.props.caption} />
                <meta property="og:image" content={this.props.generic && this.props.generic.image ? this.props.generic.image : this.props.picture} />
                <meta property="og:url" content={"https://startupguide.com/" + this.props.slug}></meta>
                <meta property="og:site_name" content="StartupGuide"></meta>

                <meta name="twitter:card" content={this.props.twitter && this.props.twitter.type.includes('Standard') ? 'summary' : 'summary_large_image'}></meta>
                <meta name="twitter:site" content="@StartupGuideHQ"></meta>
                <meta name="twitter:creator" content={this.props.twitter && this.props.twitter.handle ? this.props.twitter.handle : '@StartupGuideHQ'}></meta>
                <meta name="twitter:title" content={this.props.twitter && this.props.twitter.title ? this.props.twitter.title : this.props.title}></meta>
                <meta name="twitter:description" content={this.props.twitter && this.props.twitter.description ? this.props.twitter.description : this.props.caption}></meta>
                <meta name="twitter:image" content={this.props.twitter && this.props.twitter.image ? this.props.twitter.image : this.props.picture}></meta>
            </Helmet>,
            <ProgressBar key="2" {...this.props} />,
            imageHeader,
            <div className="article" key="4">
                <div className="article_content">
                    {/* TODO: Enable sidebar actions
                        <ul data-w-id="6bd5f62e-e5ab-0929-bca3-4fd504ae194a" style={{opacity: 0}} className="article-actions w-hidden-small w-hidden-tiny w-list-unstyled">
                            <li className="action-list-item"><img alt="" src="images/comment.svg" width={32} height={32} className="article-action-icon comment" /></li>
                            <li className="action-list-item"><img alt="" src="images/bookmark.svg" width={32} height={32} className="article-action-icon bookmark" /></li>
                            <li className="action-list-item"><img alt="" src="images/twitter.svg" width={32} height={32} className="article-action-icon twitter" /></li>
                            <li className="action-list-item"><img alt="" src="images/facebook.svg" width={32} height={32} className="article-action-icon facebook" /></li>
                        </ul>*/}
                    {this.props.slices.map((s, sk, slices) =>
                        <div key={sk}>
                            {s.type === 'intro' &&
                                <div className="article-container w-clearfix">
                                    <img alt="" src={s.intro.initialLetter} width={34} className="image-46" />
                                    {s.intro.hyperlink_content && s.intro.hyperlink_content.length > 0 && s.intro.hyperlink_content[0].text !== "" &&
                                        <React.Fragment>
                                            {s.intro.hyperlink_content.map((p, k) =>
                                                <div key={k} className="paragraph-info">
                                                    {RichText.render([p], LinkResolver, (type, element, content, children, key) => {
                                                        let props = {}
                                                        if (type === RichText.Elements.hyperlink) {
                                                            const targetAttr = element.data.target ? { target: element.data.target } : {};
                                                            const relAttr = element.data.target ? { rel: 'noopener' } : {};
                                                            props = Object.assign({
                                                                style: { textDecoration: 'underline' },
                                                                href: element.data.url || LinkResolver(element.data),
                                                                target: element.data.url ? '_blank' : ''
                                                            }, targetAttr, relAttr)
                                                            return React.createElement('a', Object.assign(props || {}, { key }), children)
                                                        }
                                                        return null
                                                    })}
                                                </div>
                                            )}
                                        </React.Fragment>
                                    }
                                    {(!s.intro.hyperlink_content || s.intro.hyperlink_content.length <= 0 || s.intro.hyperlink_content[0].text === "") &&
                                        <p className="paragraph-intro">{s.intro.text}</p>
                                    }
                                </div>
                            }
                            {s.type === 'inline_picture' && blockLazy &&
                                <div className="article-container w-clearfix">
                                    <div className="article-content-image-and-caption">
                                        <img alt="" src={s.inlinePicture.picture} />
                                        <p className="image-caption left">{s.inlinePicture.caption}</p>
                                    </div>
                                </div>
                            }
                            {s.type === 'inline_picture' && !blockLazy &&
                                <LazyLoad offsetVertical={100} debounce={false}>
                                    <div className="article-container w-clearfix">
                                        <div className="article-content-image-and-caption">
                                            <img alt="" src={s.inlinePicture.picture} />
                                            <p className="image-caption left">{s.inlinePicture.caption}</p>
                                        </div>
                                    </div>
                                </LazyLoad>
                            }
                            {s.type === 'text___picture' &&
                                <div className={'text-pic article-container w-clearfix ' + ((s.textPicture.content[0].label === 'Left Align') ? 'text-left' : 'text-right')}>
                                    <div className='tp-container tp-img'>
                                        <img src={s.textPicture.picture} alt="" />
                                    </div>

                                    <div className="tp-container">
                                        {s.textPicture.content.map((p, k) =>
                                            <div key={k} >
                                                {p.type === 'heading1' &&
                                                    <h1 className="article-secondary-headline margin-top-0px">
                                                        {RichText.render([p], LinkResolver)}
                                                    </h1>
                                                }
                                                {p.type === 'heading2' &&
                                                    <h2 className="article-secondary-headline margin-top-0px">
                                                        {RichText.render([p], LinkResolver)}
                                                    </h2>
                                                }
                                                {p.type === 'heading3' &&
                                                    <h3 className="article-secondary-headline margin-top-0px">
                                                        {RichText.render([p], LinkResolver)}
                                                    </h3>
                                                }
                                                {p.type === 'heading4' &&
                                                    <h4 className="article-secondary-headline margin-top-0px">
                                                        {RichText.render([p], LinkResolver)}
                                                    </h4>
                                                }
                                                {p.type === 'heading5' &&
                                                    <h5 className="article-secondary-headline margin-top-0px">
                                                        {RichText.render([p], LinkResolver)}
                                                    </h5>
                                                }
                                                {p.type === 'heading6' &&
                                                    <h6 className="article-secondary-headline margin-top-0px">
                                                        {RichText.render([p], LinkResolver)}
                                                    </h6>
                                                }
                                                {p.type === 'o-list-item' &&
                                                    <div className="paragraph-normal-2 clearfix">
                                                        {RichText.render([p], LinkResolver, (type, element, content, children, key) => {
                                                            let props = {}
                                                            if (type === RichText.Elements.oListItem) {
                                                                const numberElement = React.createElement(
                                                                    'span',
                                                                    Object.assign({ className: 'numbers numbers', style: { marginTop: '-4px' } } || {}, { key: 'number-' + key }),
                                                                    [(++listKey) + '.']
                                                                )
                                                                return React.createElement(
                                                                    'span',
                                                                    Object.assign(props || {}, { key }),
                                                                    [numberElement].concat(children)
                                                                )
                                                            }
                                                            if (type === RichText.Elements.oList) {
                                                                return React.createElement('span', Object.assign(props || {}, { key }), children)
                                                            }
                                                            if (type === RichText.Elements.hyperlink) {
                                                                const targetAttr = element.data.target ? { target: element.data.target } : {};
                                                                const relAttr = element.data.target ? { rel: 'noopener' } : {};
                                                                props = Object.assign({
                                                                    style: { textDecoration: 'underline' },
                                                                    href: element.data.url || LinkResolver(element.data),
                                                                    target: element.data.url ? '_blank' : ''
                                                                }, targetAttr, relAttr)
                                                                return React.createElement('a', Object.assign(props || {}, { key }), children)
                                                            }
                                                            return null
                                                        })}
                                                    </div>
                                                }
                                                {p.type === 'list-item' &&
                                                    <div className="paragraph-normal-2">
                                                        {RichText.render([p], LinkResolver)}
                                                    </div>
                                                }
                                                {(() => {
                                                    if (p.type === 'paragraph') {
                                                        return (
                                                            <div className="paragraph-normal-2" style={{ display: 'block', marginTop: (slices[sk - 1].type === 'intro' && k === 0) ? 38 : 8, marginBottom: 8 }}>
                                                                {RichText.render([p], LinkResolver, (type, element, content, children, key) => {
                                                                    let props = {}
                                                                    if (type === RichText.Elements.hyperlink) {
                                                                        // console.log("Slices?",slices);
                                                                        // console.log("Current?",slices[sk]);
                                                                        // console.log("Previous?",slices[sk-1]);

                                                                        const targetAttr = element.data.target ? { target: element.data.target } : {};
                                                                        const relAttr = element.data.target ? { rel: 'noopener' } : {};
                                                                        props = Object.assign({
                                                                            style: { textDecoration: 'underline' },
                                                                            href: element.data.url || LinkResolver(element.data),
                                                                            target: element.data.url ? '_blank' : ''
                                                                        }, targetAttr, relAttr)
                                                                        return React.createElement('a', Object.assign(props || {}, { key }), children)
                                                                    }
                                                                    return null
                                                                })}
                                                            </div>
                                                        )
                                                    }
                                                })()}
                                            </div>
                                        )}
                                    </div>

                                </div>
                            }
                            {s.type === 'paragraph' && s.paragraph.map((p, k) =>
                                <div key={k} className="article-container w-clearfix">
                                    {p.type === 'heading1' &&
                                        <h1 className="article-secondary-headline margin-top-0px">
                                            {RichText.render([p], LinkResolver)}
                                        </h1>
                                    }
                                    {p.type === 'heading2' &&
                                        <h2 className="article-secondary-headline margin-top-0px">
                                            {RichText.render([p], LinkResolver)}
                                        </h2>
                                    }
                                    {p.type === 'heading3' &&
                                        <h3 className="article-secondary-headline margin-top-0px">
                                            {RichText.render([p], LinkResolver)}
                                        </h3>
                                    }
                                    {p.type === 'heading4' &&
                                        <h4 className="article-secondary-headline margin-top-0px">
                                            {RichText.render([p], LinkResolver)}
                                        </h4>
                                    }
                                    {p.type === 'heading5' &&
                                        <h5 className="article-secondary-headline margin-top-0px">
                                            {RichText.render([p], LinkResolver)}
                                        </h5>
                                    }
                                    {p.type === 'heading6' &&
                                        <h6 className="article-secondary-headline margin-top-0px">
                                            {RichText.render([p], LinkResolver)}
                                        </h6>
                                    }
                                    {p.type === 'o-list-item' &&
                                        <div className="paragraph-normal-2 clearfix">
                                            {RichText.render([p], LinkResolver, (type, element, content, children, key) => {
                                                let props = {}
                                                if (type === RichText.Elements.oListItem) {
                                                    const numberElement = React.createElement(
                                                        'span',
                                                        Object.assign({ className: 'numbers numbers', style: { marginTop: '-4px' } } || {}, { key: 'number-' + key }),
                                                        [(++listKey) + '.']
                                                    )
                                                    return React.createElement(
                                                        'span',
                                                        Object.assign(props || {}, { key }),
                                                        [numberElement].concat(children)
                                                    )
                                                }
                                                if (type === RichText.Elements.oList) {
                                                    return React.createElement('span', Object.assign(props || {}, { key }), children)
                                                }
                                                if (type === RichText.Elements.hyperlink) {
                                                    const targetAttr = element.data.target ? { target: element.data.target } : {};
                                                    const relAttr = element.data.target ? { rel: 'noopener' } : {};
                                                    props = Object.assign({
                                                        style: { textDecoration: 'underline' },
                                                        href: element.data.url || LinkResolver(element.data),
                                                        target: element.data.url ? '_blank' : ''
                                                    }, targetAttr, relAttr)
                                                    return React.createElement('a', Object.assign(props || {}, { key }), children)
                                                }
                                                return null
                                            })}
                                        </div>
                                    }
                                    {p.type === 'list-item' &&
                                        <div className="paragraph-normal-2">
                                            {RichText.render([p], LinkResolver)}
                                        </div>
                                    }
                                    {(() => {
                                        if (p.type === 'paragraph') {
                                            return (
                                                <div className="paragraph-normal-2" style={{ display: 'block', marginTop: (slices[sk - 1].type === 'intro' && k === 0) ? 38 : 8, marginBottom: 8 }}>
                                                    {RichText.render([p], LinkResolver, (type, element, content, children, key) => {
                                                        let props = {}
                                                        if (type === RichText.Elements.hyperlink) {
                                                            // console.log("Slices?",slices);
                                                            // console.log("Current?",slices[sk]);
                                                            // console.log("Previous?",slices[sk-1]);

                                                            const targetAttr = element.data.target ? { target: element.data.target } : {};
                                                            const relAttr = element.data.target ? { rel: 'noopener' } : {};
                                                            props = Object.assign({
                                                                style: { textDecoration: 'underline' },
                                                                href: element.data.url || LinkResolver(element.data),
                                                                target: element.data.url ? '_blank' : ''
                                                            }, targetAttr, relAttr)
                                                            return React.createElement('a', Object.assign(props || {}, { key }), children)
                                                        }
                                                        return null
                                                    })}
                                                </div>
                                            )
                                        }
                                    })()}
                                </div>
                            )}
                            {s.type === 'quote' &&
                                <div className="article-container w-clearfix">
                                    <div className="div-block-54 w-clearfix">
                                        <img alt="" src={quotationTopIcon} width={23} className="image-53" />
                                        <blockquote className="p-blockquote">{s.quote}</blockquote>
                                        <img alt="" src={quotationBottomIcon} width={25} className="image-54" />
                                    </div>
                                </div>
                            }
                            {s.type === 'highlighted_picture' && !blockLazy &&
                                <LazyLoad offsetVertical={100} debounce={false}>
                                    <div className="article-image-large">
                                        <div className="div-block-12" style={{ textAlign: 'center' }}><img alt="" src={s.highlightedPicture.picture} /></div>
                                        <div className="image-caption">
                                            <div className="article-container">
                                                <p className="image-caption left">{s.highlightedPicture.caption}</p>
                                            </div>
                                        </div>
                                    </div>
                                </LazyLoad>
                            }
                            {s.type === 'highlighted_picture' && blockLazy &&
                                <div className="article-image-large">
                                    <div className="div-block-12" style={{ textAlign: 'center' }}><img alt="" src={s.highlightedPicture.picture} /></div>
                                    <div className="image-caption">
                                        <div className="article-container">
                                            <p className="image-caption left">{s.highlightedPicture.caption}</p>
                                        </div>
                                    </div>
                                </div>
                            }
                            {s.type === 'picture_duo' && !blockLazy &&
                                <LazyLoad offsetVertical={100} debounce={false}>
                                    <div className="article-container w-clearfix">
                                        <div className="twoimages w-row">
                                            <div className="column-43 w-col w-col-6 w-col-small-6">
                                                <img alt="" src={s.pictureDuo[0].picture} />
                                            </div>
                                            <div className="column-43 w-col w-col-6 w-col-small-6">
                                                <img alt="" src={s.pictureDuo[1].picture} />
                                            </div>
                                        </div>
                                    </div>
                                </LazyLoad>
                            }
                            {s.type === 'picture_duo' && blockLazy &&
                                <div className="article-container w-clearfix">
                                    <div className="twoimages w-row">
                                        <div className="column-43 w-col w-col-6 w-col-small-6">
                                            <img alt="" src={s.pictureDuo[0].picture} />
                                        </div>
                                        <div className="column-43 w-col w-col-6 w-col-small-6">
                                            <img alt="" src={s.pictureDuo[1].picture} />
                                        </div>
                                    </div>
                                </div>
                            }
                            {(s.type === 'embed' && ((this.INSTARegex.test(s.embed)) || (this.FBRegex.test(s.embed)) || (this.loadedTwitter && this.TWTTRRegex.test(s.embed)))) && !blockLazy &&
                                <LazyLoad offsetVertical={100} debounce={false}>
                                    <div className="article-container w-clearfix">
                                        <div className="social-media-embed">
                                            <div className="html-embed w-embed">
                                                <div dangerouslySetInnerHTML={{ __html: s.embed }} />
                                            </div>
                                        </div>
                                    </div>
                                </LazyLoad>
                            }
                            {(s.type === 'embed' && ((this.INSTARegex.test(s.embed)) || (this.FBRegex.test(s.embed)) || (this.loadedTwitter && this.TWTTRRegex.test(s.embed)))) && blockLazy &&
                                <div className="article-container w-clearfix">
                                    <div className="social-media-embed">
                                        <div className="html-embed w-embed">
                                            <div dangerouslySetInnerHTML={{ __html: s.embed }} />
                                        </div>
                                    </div>
                                </div>
                            }
                        </div>
                    )}
                    <div className="article-container w-clearfix">
                        {!blockLazy &&
                            <LazyLoad offsetVertical={100} debounce={false}>
                                <div className="article-footer" style={{ marginBottom: '50px' }}>
                                    {this.props.sponsor &&
                                        <div className="sponsor margin-bottom-24px" style={{ borderColor: this.props.group.color }}>
                                            <div className="row-6 w-row">
                                                <div className="column-45 w-col w-col-4 w-col-small-6 w-col-tiny-6">
                                                    <img alt="" src={this.props.sponsor.logo} width={169} className="image-51" />
                                                </div>
                                                <div className="column-46 w-col w-col-8 w-col-small-6 w-col-tiny-6">
                                                    <p className="margin-bottom-8px">
                                                        This post was created in partnership with {this.props.sponsor.name}.<br />
                                                        {this.props.sponsor.description}
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    }
                                    <div className="author-details">
                                        <div className="row-7 w-row">
                                            <div className="column-11 w-col w-col-4">
                                                <img alt="" src={this.props.author.picture} width={173} className="image-50" />
                                            </div>
                                            <div className="column-12 w-col w-col-8">
                                                <div className="author-data w-clearfix">
                                                    { this.props.author && (<h4 className="margin-bottom-8px">{this.props.author.firstname} {this.props.author.lastname}</h4>)}
                                                    <p className="margin-bottom-8px">{this.props.author.biography}</p>
                                                    <ul className="article-author-social-icons margin-bottom-0px w-list-unstyled">
                                                        {this.props.author.facebook !== '' &&
                                                            <li className="icon">
                                                                <a href={this.props.author.facebook} target="_blank">
                                                                    <img alt="" src={facebookIcon} width="24" height="24" />
                                                                </a>
                                                            </li>
                                                        }
                                                        {this.props.author.twitter !== '' &&
                                                            <li className="icon">
                                                                <a href={this.props.author.twitter} target="_blank">
                                                                    <img alt="" src={twitterIcon} width="24" height="24" />
                                                                </a>
                                                            </li>
                                                        }
                                                        {this.props.author.instagram !== '' &&
                                                            <li className="icon">
                                                                <a href={this.props.author.instagram} target="_blank">
                                                                    <img alt="" src={instagramIcon} width="24" height="24" />
                                                                </a>
                                                            </li>
                                                        }
                                                        {this.props.author.linkedin !== '' &&
                                                            <li className="icon">
                                                                <a href={this.props.author.linkedin} target="_blank">
                                                                    <img alt="" src={linkedinIconGray} width="24" height="24" />
                                                                </a>
                                                            </li>
                                                        }
                                                        {this.props.author.website !== '' &&
                                                            <li className="icon">
                                                                <a href={this.props.author.website} target="_blank">
                                                                    <img alt="" src={websiteIcon} width="24" height="24" />
                                                                </a>
                                                            </li>
                                                        }
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </LazyLoad>
                        }
                        {blockLazy &&
                            <div className="article-footer" style={{ marginBottom: '50px' }}>
                                {this.props.sponsor &&
                                    <div className="sponsor margin-bottom-24px" style={{ borderColor: this.props.group.color }}>
                                        <div className="row-6 w-row">
                                            <div className="column-45 w-col w-col-4 w-col-small-6 w-col-tiny-6">
                                                <img alt="" src={this.props.sponsor.logo} width={169} className="image-51" />
                                            </div>
                                            <div className="column-46 w-col w-col-8 w-col-small-6 w-col-tiny-6">
                                                <p className="margin-bottom-8px">
                                                    This post was created in partnership with {this.props.sponsor.name}.<br />
                                                    {this.props.sponsor.description}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                }
                                <div className="author-details">
                                    <div className="row-7 w-row">
                                        <div className="column-11 w-col w-col-4">
                                            <img alt="" src={this.props.author.picture} width={173} className="image-50" />
                                        </div>
                                        <div className="column-12 w-col w-col-8">
                                            <div className="author-data w-clearfix">
                                                { this.props.author && (<h4 className="margin-bottom-8px">{this.props.author.firstname} {this.props.author.lastname}</h4>)}
                                                <p className="margin-bottom-8px">{this.props.author.biography}</p>
                                                <ul className="article-author-social-icons margin-bottom-0px w-list-unstyled">
                                                    {this.props.author.facebook !== '' &&
                                                        <li className="icon">
                                                            <a href={this.props.author.facebook} target="_blank">
                                                                <img alt="" src={facebookIcon} width="24" height="24" />
                                                            </a>
                                                        </li>
                                                    }
                                                    {this.props.author.twitter !== '' &&
                                                        <li className="icon">
                                                            <a href={this.props.author.twitter} target="_blank">
                                                                <img alt="" src={twitterIcon} width="24" height="24" />
                                                            </a>
                                                        </li>
                                                    }
                                                    {this.props.author.instagram !== '' &&
                                                        <li className="icon">
                                                            <a href={this.props.author.instagram} target="_blank">
                                                                <img alt="" src={instagramIcon} width="24" height="24" />
                                                            </a>
                                                        </li>
                                                    }
                                                    {this.props.author.website !== '' &&
                                                        <li className="icon">
                                                            <a href={this.props.author.website} target="_blank">
                                                                <img alt="" src={websiteIcon} width="24" height="24" />
                                                            </a>
                                                        </li>
                                                    }
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                    <NewsletterForm />
                    <div className="h-divider" />
                </div>
            </div>,
            recomendations

        ]
    }
}

const connectRelay = ArticlePage => class extends Component {

    render() {
        if (this.props.article) {
            const { routeResolver } = this.props.context
            const props = {
                publishedAt: moment(this.props.article.publishedAt),
                slug: this.props.article.slug,
                title: this.props.article.title,
                forceTitleToAppearUnderneath: this.props.article.forceTitleToAppearUnderneath,
                caption: this.props.article.caption,
                readingTime: msToReadingTime(this.props.article.readingTime),
                picture: this.props.article.picture,
                widePicture: this.props.article.widePicture,
                videoLink: this.props.article.videoLink,
                author: this.props.article.author,
                sponsor: this.props.article.sponsor,
                group: this.props.article.city ? {
                    link: routeResolver.location.get(this.props.article.city.slug),
                    latestArticles: this.props.article.city.articles
                        .filter(a => a.slug !== this.props.article.slug)
                        .map(a => ({
                            ...a,
                            link: routeResolver.article.get(this.props.article.city.slug, a.slug),
                        })),
                    ...this.props.article.city,
                } : {
                    link: routeResolver.category.get(this.props.article.category.slug),
                    latestArticles: this.props.article.category.articles
                        .filter(a => a.slug !== this.props.article.slug)
                        .map(a => ({
                            ...a,
                            link: routeResolver.article.get(this.props.article.category.slug, a.slug),
                        })),
                    ...this.props.article.category,
                },
                slices: this.props.article.slices,
                seo: this.props.article.seo,
                generic: this.props.article.social.generic[0],
                twitter: this.props.article.social.twitter[0],
            }

            if (window.mobilecheck()) {
                // window.location =  '/AMP/' + this.props.article.slug + '.html'
            }
            var amplink = document.createElement("link");
            amplink.setAttribute("rel", "amphtml");
            amplink.setAttribute("href", "http://amp.startupguide.com/" + this.props.article.slug);
            document.head.appendChild(amplink);

            var cannonicalLink = document.createElement("link");
            cannonicalLink.setAttribute("rel", "canonical");
            cannonicalLink.setAttribute("href", "https://startupguide.com/" + this.props.article.slug);
            document.head.appendChild(cannonicalLink);

            var sc = document.createElement("script");
            sc.setAttribute("type", "application/ld+json");
            sc.text = `
            {
              "@context": "http://schema.org",
              "@type": "BlogPosting",
              "mainEntityOfPage": {
                "@type": "WebPage",
                "@id": "https://startupguide.com"
              },
              "headline": "`+ this.props.article.title + `",
              "image": [
                "`+ this.props.article.picture + `"
              ],
              "datePublished": "`+ moment(this.props.article.publishedAt).format('YYYY-MM-DD') + `",
              "dateModified": "`+ moment(this.props.article.publishedAt).format('YYYY-MM-DD') + `",
              "author": {
                "@type": "Person",
                "name": "`+ this.props.article.author ? this.props.article.author.firstname + ' ' + this.props.article.author.lastname : '' + `" 
              },
              "publisher": {
                "@type": "Organization",
                "name": "Startup Guide",
               "logo": {
                  "@type": "ImageObject",
                  "url": "https://startupguide.com/images/publisher_logo.png"
                }
              },
              "description": ` + JSON.stringify(this.props.article.caption) + `
            }
            `
            document.head.appendChild(sc);
            // document.querySelector('head').appendChild(`<script>console.log('oi')</script>`)

            return <ArticlePage {...props} />
        }
        
        return <ErrorPage />
    }
}

export default createFragmentContainer(
    connectRelay(ArticlePage),
    graphql`
        fragment articlePage_article on Article {
            publishedAt
            slug
            title
            forceTitleToAppearUnderneath
            caption
            readingTime
            picture
            widePicture
            videoLink
            author {
                firstname
                lastname
                biography
                picture
                facebook
                twitter
                instagram
                linkedin
                website
            }
            sponsor {
                name
                description
                logo
            }
            city {
                slug
                name
                color
                articles(first: 7) {
                    slug
                    title
                    caption
                    readingTime
                    picture
                    author {
                        firstname
                        lastname
                    }
                }
            }
            cities {
                slug
                name
                color
                articles(first: 7) {
                    slug
                    title
                    caption
                    readingTime
                    picture
                    author {
                        firstname
                        lastname
                    }
                }
            }
            category {
                slug
                name
                color
                articles(first: 7) {
                    slug
                    title
                    caption
                    readingTime
                    picture
                    author {
                        firstname
                        lastname
                    }
                }
            }
            slices {
                type
                intro {
                    initialLetter
                    text
                    hyperlink_content{
                        type
                        text
                        spans{
                            data{
                                id
                                uid
                                url
                                type
                                slug
                                link_type
                            }
                            start
                            end
                            type
                        }
                        label
                    }
                }
                pictureDuo {
                    picture
                    caption
                }
                inlinePicture {
                    picture
                    caption
                }
                highlightedPicture {
                    picture
                    caption
                }
                quote
                embed
                paragraph {
                    type
                    text
                    spans {
                        start
                        end
                        type
                        data {
                            id
                            uid
                            type
                            slug
                            link_type
                            url
                        }
                    }
                }
                textPicture{
                    picture
                      content{
                          type
                          text
                          label
                        spans{
                          data{
                            id
                            uid
                            type
                            slug
                            url
                            link_type
                          }
                          start
                          end
                          type
                        }
                    }
                  }
            }
            seo {
              title
              description
            }
            social {
              twitter {
                type
                title
                image
                handle
                description
              }
              generic {
                title
                image
                description
              }
            }
        }
    `
)

function calculateVisibilityForDiv(div$) {
    var windowHeight = $(window).height(),
        docScroll = $(document).scrollTop(),
        divPosition = div$.offset().top,
        divHeight = div$.height(),
        // hiddenBefore = docScroll - divPosition,
        hiddenAfter = (divPosition + divHeight) - (docScroll + windowHeight);

    if ((docScroll > divPosition + divHeight) || (divPosition > docScroll + windowHeight)) {
        return 0;
    } else {
        var result = 100;

        // if (hiddenBefore > 0) {
        //     result -= (hiddenBefore * 100) / divHeight;
        // }

        if (hiddenAfter > 0) {
            result -= (hiddenAfter * 100) / divHeight;
        }

        return result;
    }
}

window.mobilecheck = function () {
    var check = false;
    // eslint-disable-next-line no-useless-escape
    (function (a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true; })(navigator.userAgent || navigator.vendor || window.opera);
    return check;
};